import{a as t}from"./chunk-5TYRO4AV.js";import n from"react";var i=({element:e})=>e?.network?n.createElement(t,{network:e.network||"",network_id:e.network_id||"",enable_caption:e.enable_caption||!1}):null;export{i as a};
